/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.IpRestrictions {
    angular.module("meevo.plugins.ipRestrictions", []);
}